<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper farmListAdd" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal small farmListAdd" style="top: 0;">
				<div class="modalContent">
					<div class="functionPanel">
						<a @click="onModalClose(close)" @mouseover="cancelHover = true" @mouseleave="cancelHover = false" class="closeWindow clickable" play-on-click="7">
							<i :class="['closeWindow', {action_cancel_small_flat_black: !cancelHover, action_cancel_small_flat_green: cancelHover}]"></i>
						</a>
					</div>
					<div class="contentHeader">
						<h2 ng-if="!w.contentHeaderText" ng-class="::{static: w.params.modalParams.staticPosition}" class=" msAntiScroll" draggable="true">
							<span translate="" options="FarmList.ListAddVillage.headline" data=""><span>Добавить деревню в список целей</span></span>
						</h2>
						<!-- ngIf: w.contentHeaderText -->
					</div>
					<div class="farmListAdd" ng-controller="farmListAddCtrl">
						<div class="farmListWrapper scrollable" scrollable="">
							<div class="scrollContentOuterWrapper" style="width: 348px;">
								<div class="scrollContent" dynamic-height="false" style="width: 348px; overflow-y: hidden;">
									<div class="scrollContentInnerWrapper" ng-transclude="" style="width: auto;">
										<div class="farmListInner" on-pointer-over="removePreselected()">
											<!-- ngIf: action === FarmListEntry.ACTION.TOGGLE -->
											<h6 ng-if="action !== FarmListEntry.ACTION.TOGGLE">
												<span translate="" data="targetId: 536100851, targetName: Оазис (-13|-24)"><span>Добавить </span><a ng-class="{disabled: villId <= 2 || nolink}" class="truncated villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536100851}, null, true)" villageid="536100851" villagename="Оазис (-13|-24)" nolink="" showmissinglink="true">Оазис (-13|-24)</a></span>
											</h6>
											<div class="list clickable" ng-repeat="(key, farmlist) in farmListCollection" clickable="addVillage(325)" ng-if="farmlist.data.isDefault || player.hasPlusAccount()" ng-class="{'preselected': key === 0 &amp;&amp; preselected}">
												<i class="action_check_small_flat_green" ng-if="villageInFarmLists.indexOf(farmlist.data.listId) > -1"></i>
												<!-- ngIf: villageInFarmLists.indexOf(farmlist.data.listId) === -1 -->
												Стартовый лист
												<span>
													<i class="village_village_small_flat_black" tooltip="" tooltip-translate="FarmList.Tooltip.villages" ng-click="$event.stopPropagation()"></i>
													3/10
												</span>
											</div>
											<div class="list clickable" ng-repeat="(key, farmlist) in farmListCollection" clickable="addVillage(325)" ng-if="farmlist.data.isDefault || player.hasPlusAccount()" ng-class="{'preselected': key === 0 &amp;&amp; preselected}">
												<!-- ngIf: villageInFarmLists.indexOf(farmlist.data.listId) > -1 -->
												<i class="action_check_small_flat_black" ng-if="villageInFarmLists.indexOf(farmlist.data.listId) === -1"></i>
												Стартовый лист
												<span>
													<i class="village_village_small_flat_black" tooltip="" tooltip-translate="FarmList.Tooltip.villages" ng-click="$event.stopPropagation()"></i>
													2/10
												</span>
											</div>
											<!-- ngIf: error -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="window-overlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>